// extracted by mini-css-extract-plugin
export default {"button":"Button_button__E2EFk","buttonSecondary":"Button_buttonSecondary__UfmPK","negative":"Button_negative__EY5tJ"};